
import SzCard from "@/components/basics/SzCard.vue";
import {
  defineComponent,
  reactive,
  onActivated,
  ref,
  toRefs,
  computed,
} from "vue";
import $api from "@/api/main";
import { ElMessage } from "element-plus";
import utils from "@/utils/utils";
import { dayFunc } from "@/hooks/factoryFunc";
export default defineComponent({
  name:'pcWorkbenchBilling',
  components: { SzCard },
  setup(props, context) {
    const { dayjs } = dayFunc();
    let data: any = reactive({
      treeList: [],
      projectList: [],
      customerList: [],
      taxList: [],
      approver: [],
      taxTypeList: [],
      collectionTypeList:[],
    });

    const collectionForm = ref(null);

    const whetherAllValidator = (rule: any, value: any, callback: any) => {
      let model = ((collectionForm.value) as any).model;
      if(model.collectionType == '02' && (value == null || value == '')) {
        callback(new Error('请选择是否全部完成收款'));
        return
      }
      callback();
    };

    const rules = {
      tenantName: [{ required: true, message: "请输入合同名称" }],
      projectId: [{ required: true, message: "请选择所属项目" }],
      customerName: [{ required: true, message: "请选择" }],
      applicant: [{ required: true, message: "请选择" }],
      tfn: [{ required: true, message: "请输入" }],
      registerAddress: [{ required: true, message: "请输入" }],
      registerPhone: [{ required: true, message: "请输入" }],
      bankAccount: [{ required: true, message: "请输入" }],
      depositBank: [{ required: true, message: "请输入" }],
      invoiceAmount: [{ required: true, message: "请输入" }],
      tax: [{ required: true, message: "请选择" }],
      invoiceType: [{ required: true, message: "请选择" }],
      confirm: [{ required: true, message: "请选择" }],
      remark: [{ required: true, message: "请输入" }],
      collectionType: [{ required: true, message: "请选择收款类型" }],
      planReceivedAmount: [{ required: true, message: "请输入计划收款金额" }],
      //当collectionType为质保金时，whetherAll必填
      whetherAll: [{ validator: whetherAllValidator,trigger: 'blur' }]
    };

    onActivated(() => {
      //
      $api.getEmployeesTree().then((res: any) => {
        if (res) {
          data.treeList = res;
        }
      });
      $api.getProjectList().then((res: any) => {
        if (res) {
          data.projectList = res;
        }
      });
      $api.getCustomerListIng().then((res: any) => {
        if (res) {
          data.customerList = res;
        }
      });
      $api.getDir("TAX_CALCULATION_METHOD").then((res: Array<never>) => {
        data.taxList = res;
      });
      $api.getDir("COLLECTION_TYPE").then((res: Array<never>) => {
        data.collectionTypeList = res;
      });
      $api.getDir("INVOICE_TYPE").then((res: Array<never>) => {
        data.taxTypeList = res;
      });
    });
    return {
      dayjs,
      rules,
      data,
      collectionForm
    };
  },
  data() {
    return {
      hxStaffDept: utils.$cookie.getCookie("hxStaffDept"),
      ruleForm: {
        applicant: utils.$cookie.getCookie("hxUserCode"),
        tenantName: window.sessionStorage.getItem("tenantName"),
        flowStatus:'',
        projectId: "",
        customerName: "",
        tfn: "",
        registerAddress: "",
        registerPhone: "",
        bankAccount: "",
        depositBank: "",
        invoiceAmount: "",
        tax: "",
        invoiceType: "",
        confirm: "",
        remark: "",
        files: [],
        invoiceDate: "",
        projectAddress: "",
        invoiceNumber: "",
        submit: false,
        collectionType:null,
        planReceivedAmount:'',
        whetherAll:null,
        receivedRemark:''
      },
      loading: false,
    };
  },
  activated() {
    if (this.$route.query.id) {
      $api.getInvoiceInfo(this.$route.query.id).then((res: any) => {
        this.ruleForm = res;
        this.data.approver = res.approver;
      });
    }
  },
  methods: {
    getUploadResultFn(data: any) {
      this.ruleForm.files = data;
    },
    async getProjectAddress() {
      await $api.getProjectDetails(this.ruleForm.projectId).then((res: any) => {
        let customerId = res.customerId;
        $api.getCustomerDetails(customerId).then((res1: any) => {
          this.ruleForm.customerName = res1.name;
          this.ruleForm.registerAddress = res1.registerAddress;
          this.ruleForm.registerPhone = res1.registerPhone;
          this.ruleForm.bankAccount = res1.bankAccount;
          this.ruleForm.depositBank = res1.depositBank;
          this.ruleForm.projectAddress = res1.address;
          this.ruleForm.tfn = res1.tfn;
        });
      });
      this.data.projectList.forEach((item: any) => {
        if (this.ruleForm.projectId == item.id) {
          this.ruleForm.projectAddress = item.address;
        }
      });
      await $api.getLastProcessPerson({
					processDefinitionId:'invoice_application',
					projectId: this.ruleForm.projectId
				}).then((res: any) => {
					if (res && (res instanceof Array)) {
						this.data.approver = res;
					}
				});
    },
    onCancel() {
      (this as any).$store.commit('CLEAR_ROUTE','pcWorkbenchBillingList')
      this.$router.push({
        path: "/workbench/billingList",
      });
    },
    submit(submit: boolean) {
      this.ruleForm.submit = submit;
      const _this: any = this;
      if(submit){
        _this.$refs.ruleForm.validate((valid: boolean) => {
          if (valid) {
            _this.$refs.collectionForm.validate((cvalid: boolean) => {
              if(cvalid){
                if (this.data.approver.length == 0) {
                  ElMessage({
                    type: "warning",
                    message: "请选择审核流程",
                  });
                  return;
                }
                this.submitFn();
              }
            });
          }
        });
      }else{
        this.submitFn();
      }
    },
    submitFn(){
      this.loading = true;
      let { invoiceDate, ...obj } = this.ruleForm;
      if (this.$route.query.id && !this.$route.query.isReApply) {
        $api
          .upDateInvoiceMgtInfo(
            {
              ...obj,
              invoiceDate: invoiceDate
                ? this.dayjs(invoiceDate).format("YYYY-MM-DD")
                : "",
              approver: this.data.approver,
            },
            this.$route.query.id
          )
          .then((res: Array<never>) => {
            if (res) {
              ElMessage({
                type: "success",
                message: "提交成功",
              });
              (this as any).$store.commit('CLEAR_ROUTE','pcProjectFinanceManageBilling')
              this.loading = false;
              this.onCancel();
            }
          });
      } else {
        $api
          .createInvoice({
            ...obj,
            invoiceDate: invoiceDate
              ? this.dayjs(invoiceDate).format("YYYY-MM-DD")
              : "",
            approver: this.data.approver,
          })
          .then((res: Array<never>) => {
            if (res) {
              ElMessage({
                type: "success",
                message: "新增成功",
              });
              (this as any).$store.commit('CLEAR_ROUTE','pcProjectFinanceManageBilling')
              this.loading = false;
              this.onCancel();
            }
          });
      }
    },
  },
});
